var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { staticClass: "ScreenToolbar" }, [
    _c("li", { staticClass: "ScreenToolbar_Item" }, [
      _c(
        "button",
        {
          staticClass: "ScreenToolbar_IconButton",
          class: { _disabled: _vm.isScreenFit },
          on: {
            click: function($event) {
              _vm.zoomOut()
            }
          }
        },
        [
          _c("FontAwesomeIcon", { attrs: { icon: "search-minus", size: "1x" } })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("li", { staticClass: "ScreenToolbar_Item" }, [
      _c(
        "output",
        {
          staticClass: "ScreenToolbar_Output",
          class: { _disabled: _vm.isScreenFit }
        },
        [_vm._v("\n      " + _vm._s(_vm.zoomValue) + "\n    ")]
      )
    ]),
    _vm._v(" "),
    _c("li", { staticClass: "ScreenToolbar_Item" }, [
      _c(
        "button",
        {
          staticClass: "ScreenToolbar_IconButton",
          class: { _disabled: _vm.isScreenFit },
          on: {
            click: function($event) {
              _vm.zoomIn()
            }
          }
        },
        [_c("FontAwesomeIcon", { attrs: { icon: "search-plus", size: "1x" } })],
        1
      )
    ]),
    _vm._v(" "),
    _c("li", { staticClass: "ScreenToolbar_Item" }, [
      _c(
        "button",
        {
          staticClass: "ScreenToolbar_IconButton",
          on: {
            click: function($event) {
              _vm.zoomFit()
            }
          }
        },
        [
          _c("FontAwesomeIcon", {
            attrs: { icon: "expand-arrows-alt", size: "1x" }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("li", { staticClass: "ScreenToolbar_Item" }, [
      _c(
        "button",
        {
          staticClass: "ScreenToolbar_IconButton ScreenToolbar_Highlight",
          on: {
            click: function($event) {
              _vm.toggleHighlight()
            }
          }
        },
        [_vm._v("\n      highlight\n    ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }